import { useEffect } from "react";
import { useLocation } from "wouter";
import { useQuery } from "@tanstack/react-query";
import type { Property } from "@shared/schema";
import { usePageTitle } from "@/hooks/use-page-title";

const LAST_PROPERTY_STORAGE_KEY = "padpulse:lastSelectedPropertyId";

export default function AppImageGenerator() {
  usePageTitle("Image Generator");
  const [, navigate] = useLocation();

  const propertiesQuery = useQuery<Property[]>({
    queryKey: ["/api/app/properties"],
  });

  useEffect(() => {
    if (propertiesQuery.isLoading) return;
    const properties = propertiesQuery.data || [];
    let target: Property | undefined;
    try {
      const stored = parseInt(window.localStorage.getItem(LAST_PROPERTY_STORAGE_KEY) || "", 10);
      if (!isNaN(stored)) {
        target = properties.find(p => p.id === stored);
      }
    } catch {
      // ignore localStorage errors
    }
    if (!target) {
      target = properties.find(p => p.status === "active" || p.status === "launch");
    }
    if (target) {
      navigate(`/app/properties/${target.id}?tab=rooms&view=images`, { replace: true });
    } else {
      navigate("/app/properties", { replace: true });
    }
  }, [propertiesQuery.isLoading, propertiesQuery.data, navigate]);

  return null;
}
